export const pspm2 = (
  <div
    className={
      'h-full flex-1 border-2 border-[rgba(255,0,207,0.15)] bg-[rgba(255,0,207,0.05)]'
    }
  />
);
export const ps30 = (
  <div className="h-full flex-1 rounded-[15px] border-2 border-[#3C358B] opacity-70" />
);
export const psi36 = (
  <div className="h-full flex-1 border-2 border-[rgba(132,53,0,0.3)] bg-[rgba(132,53,0,0.25)] " />
);
export const psi4 = (
  <div className={'h-full flex-1 border-2 border-orange-300 bg-orange-100'} />
);
export const psi21 = (
  <div className={'h-full flex-1 border-2 border-purple-400 bg-purple-200'} />
);
export const ps31 = (
  <div
    className={
      'h-full flex-1 border-2 border-[#1f8fff] bg-[#86bef7] opacity-60'
    }
  />
);
export const ls11a = (
  <div className="flex h-full flex-1 items-center justify-center bg-white">
    <div className="w-full border-b-[3px] border-dashed border-b-[#FF0400] opacity-5" />
  </div>
);
export const ls31 = (
  <div className="flex h-full flex-1 items-center justify-center bg-white">
    <div className="w-full border-b-[3px] border-b-[#1F8FFF] opacity-40" />
  </div>
);
export const ls32 = (
  <div className="flex h-full flex-1 items-center justify-center bg-white">
    <div className="w-full rounded-[3px] border-y-2 border-y-[#9BE83C] opacity-50" />
  </div>
);
export const ls24 = (
  <div className="flex h-full flex-1 items-center justify-center bg-white">
    <div className="w-full border-b-2 border-b-[#414141] opacity-40" />
  </div>
);
export const ls28 = (
  <div className="flex h-full flex-1 items-center justify-center bg-white">
    <div className="w-full border-b-2 border-b-[#B15BA2] opacity-80" />
  </div>
);
export const lsi4 = (
  <div className="flex h-full flex-1 items-center justify-center bg-white">
    <div className="w-full border-b-2 border-b-orange-300" />
  </div>
);
export const pluAvailabilityIcon = (
  <div className="h-full flex-1 border-2 border-seafoam-200 bg-seafoam-100 opacity-80" />
);
export const floorAreaPrecisionIcon = (
  <div className="h-full flex-1 border-2 border-orange-500 bg-orange-400 opacity-80" />
);
export const zoningIcon = (
  <div className="h-full flex-1 border-2 border-seafoam-400 opacity-80" />
);
export const landUnitsIcon = (
  <div className="h-full flex-1 border-2 border-red-700 bg-red-400 opacity-60" />
);
